import React from "react";
// Sections
import TopNavbar from "./elements/TopNavbar";
import Header from "./sections/Header";
import "./style/index.css"
import "./style/flexboxgrid.min.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Services from "./sections/Services";
import Projects from "./sections/Projects";
// import Blog from "../components/Sections/Blog";
// import Pricing from "../components/Sections/Pricing";
// import Contact from "../components/Sections/Contact";
import Footer from "./sections/Footer"

export default function LandingPage() {
  return (
    <>
      {/* <TopNavbar /> */}
      <Header />
      <Services />
      <Projects />
      {/* <Blog />
      <Pricing />
      <Contact /> */}
      <Footer />
    </>
  );
}